import React from "react";

function ArrowRightUpLine() {
	return (
		<g>
			<path d='M16.0037 9.41421L7.39712 18.0208L5.98291 16.6066L14.5895 8H7.00373V6H18.0037V17H16.0037V9.41421Z'></path>
		</g>
	);
}

export default ArrowRightUpLine;
